import React from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { activeAutom } from "../../../../recoil-store/recoil-state";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

function Group ({ action, variables, setOpenVariable, setGroupLabel }) {
	const { t } = useTranslation();
	// It is not newly created TR & EN  because it has the same labels.
	const label = "CONTENT.CONFIGURATION-FORM.GROUPING.";
	const [automDetail, setAutomDetail] = useRecoilState(activeAutom);

	const updateLabel = (id, items) => {
		items.forEach(item => {
			if (item.id === id) {
				item.fields = action.fields;
			} else if (item.children) {
				updateLabel(id, item.children);
			}
		});
	};

	const handleBlur = () => {
		let fields = action.fields;
		let items = JSON.parse(JSON.stringify(automDetail.items));
		action.fields = JSON.parse(JSON.stringify(fields));
		updateLabel(action.id, items);
		setAutomDetail({ ...automDetail, items: JSON.parse(JSON.stringify(items)) });
	};
	return (
		<div>
			<div className="form-element">
				{t(label + "LABEL")}
				<TextInput
					action={action}
					inputName="label"
					variables={variables}
					setOpenVariable={setOpenVariable}
					isRequired={false}
					onBlur={handleBlur}
				/>
			</div>
		</div>
	);
}
export default Group;